// Overview data for the stjórnborð home + top bar. Served from the .NET backend
// (GET /api/atomika/overview). A tiny module cache dedupes the fetch across the
// components that render on the home page at the same time.
import { useEffect, useState } from "react";
import { api } from "./api";

export interface OverviewKpi {
  label: string;
  value: string;
  unit?: string | null;
  sub: string;
  subColor: string;
  valueColor?: string | null;
}

export interface OverviewNotif {
  dot: string;
  text: string;
  meta: string;
}

export interface OverviewActivity {
  dot: string;
  text: string;
  app: string;
  time: string;
}

export interface OverviewTask {
  dot: string;
  bg: string;
  text: string;
  meta: string;
}

export interface OverviewSystem {
  dot: string;
  name: string;
  val: string;
  color: string;
}

export interface OverviewToolStatus {
  id: string;
  statusLabel: string;
  statusColor: string;
  statusBg: string;
  statusDot: string;
  k1v: string;
  k1l: string;
  k2v: string;
  k2l: string;
  k2Color?: string | null;
  last: string;
}

export interface OverviewUser {
  name: string;
  initials: string;
}

export interface OverviewData {
  user: OverviewUser;
  kpis: OverviewKpi[];
  notifications: OverviewNotif[];
  activity: OverviewActivity[];
  tasks: OverviewTask[];
  systems: OverviewSystem[];
  tools: OverviewToolStatus[];
}

let cache: OverviewData | null = null;
let inflight: Promise<OverviewData> | null = null;

export function useOverview(): OverviewData | null {
  const [data, setData] = useState<OverviewData | null>(cache);

  useEffect(() => {
    if (cache) {
      setData(cache);
      return;
    }
    if (!inflight) {
      inflight = api.getOverview().then((d) => {
        cache = d;
        return d;
      });
    }
    let active = true;
    inflight
      .then((d) => {
        if (active) setData(d);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return data;
}

export function toolStatusById(
  data: OverviewData | null,
  id: string,
): OverviewToolStatus | undefined {
  return data?.tools.find((t) => t.id === id);
}
